module.exports = __webpack_public_path__ + "img/e46ac8ff84a74a309ebd8f5deedbd85f-1024.e7464b2d.jpg";